import { z } from 'zod';

import { stringToNumber } from '../codecs';

export type IntegrationOtcsQuery = z.output<typeof integrationOtcsQuerySchema>;
export type IntegrationOtcsQueryDTO = z.input<typeof integrationOtcsQuerySchema>;

export const integrationOtcsQuerySchema = z.object({
  /** Only return OTCs that remain valid for at least this many minutes. */
  minExpiresInMinutes: stringToNumber.pipe(z.int().positive()).optional(),
});
